import { Helmet } from 'react-helmet-async';
import MainLayout from 'src/layouts/home-layout/layout';
import Home from 'src/sections/home';
// sections

// ----------------------------------------------------------------------

export default function Page() {
  return (
    <MainLayout>
      <Helmet>
        <title>Code Engine - Global Collaboration for Innovative Product Development</title>
      </Helmet>

      <Home />
    </MainLayout>
  );
}
